import { FieldProps } from '~components/form-fields';
import FormInputDate from '~appointments/components/FormInputDate';

import common from './common';

const singleSpecific: FieldProps = {
  date: {
    type: 'custom',
    component: FormInputDate,
    caption: 'Appointment Date',
    required: true,
    colSize: 4,
    order: 120,
  },
};

const singleAppointmentNewFields: FieldProps = {
  ...common,
  ...singleSpecific,
};

export default { singleSpecific, singleAppointmentNewFields };
